/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { featureFlagCheckDataFeatureSchema } from './FeatureFlagCheckDataFeatureSchema'

export const featureFlagCheckDataSchema = z.object({
	feature: featureFlagCheckDataFeatureSchema,
	enabled: z.boolean(),
})

export type FeatureFlagCheckDataSchema = z.infer<typeof featureFlagCheckDataSchema>
